import { tateConfig, yokoConfig } from './sheet.config'

export const S4_CW2603_TestA_211123 = {
  FRONT: {
    EXAM_GROUP_KEY: '02425003111',
    QR_INFO: {
      checkDigit: 4316,
      correctSize: tateConfig.correctedSize,
      correctMarkers: tateConfig.correctedMarkers,
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: tateConfig.correctedRotateQrPos,
      numCheckPosition: tateConfig.correctedNumCheckArea,
      clipScale: 0.8,
      isHorizontal: false
    }
  },
  REVERSE: {
    EXAM_GROUP_KEY: '02425003122',
    QR_INFO: {
      checkDigit: 4329,
      correctSize: yokoConfig.correctedSize,
      correctMarkers: yokoConfig.correctedMarkers,
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: yokoConfig.correctedRotateQrPos,
      numCheckPosition: {
        ...yokoConfig.correctedNumCheckArea,
        l: yokoConfig.correctedNumCheckArea.l + 3
      },
      clipScale: 1.0,
      isHorizontal: true
    }
  }
} as const
